import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { LanguageToggle } from '../LanguageToggle';
import { NavMenuButton } from '../Buttons';
import { DropdownPanel } from '../DropdownPanel';
import { VerticalNavigation } from './';
import { SlidePanel } from './SlidePanel';
import media from '../../utils/media';
import { ImageLink } from '../Link';
import { IMAGE_TYPE, NAV_LOGO } from '../../constants';
const mobileNavigationContainerHeight = 50;
const navigationHeight = 51; // height of Container + 1px border from Navigation outer container
const MobileNavigationContainer = styled.div `
  display: none;
  width: 100%;
  padding: 0px 10px;
  height: ${mobileNavigationContainerHeight}px;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;

  ${media.mobile} {
    display: flex;
  }

  ${media.tablet} {
    display: flex;
  }

  ${media.smallDesktop} {
    display: flex;
  }
`;
const FlexContainer = styled.div `
  display: flex;
  justify-content: space-between;
  width: 106px;
  align-items: center;
`;
const Header = styled.div `
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;
const MobileNavigation = ({ siteOwner, navigationItems, siteLogo, currentSite, currentLanguage, languageToggleOptions, }) => {
    const [isNavMenuOpen, setNavMenuToOpen] = useState(false);
    const [childMenuData, setChildMenuData] = useState([]);
    const [childMenuLabel, setChildMenuLabel] = useState(null);
    const [shouldChildMenuOpen, setChildMenuToOpen] = useState(false);
    const clearChildMenuData = () => {
        setChildMenuToOpen(false);
        setChildMenuLabel(null);
        setChildMenuData([]);
    };
    // looks for the SiteName label to be used in secondary navigation
    const matchedNavigationItem = navigationItems.filter((navItem) => navItem.fields.url.value.href === `/${currentSite !== 'home' ? currentSite : ''}`);
    const derivedSiteName = (matchedNavigationItem &&
        matchedNavigationItem.length &&
        matchedNavigationItem[0].fields.label.value) ||
        '';
    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (isNavMenuOpen) {
                window.document.body.style.overflow = 'hidden';
                window.document.body.style.position = 'fixed';
                window.document.body.style.top = `-${window.scrollY}px`;
            }
            else {
                window.document.body.style.overflow = 'auto';
                const scrollY = document.body.style.top;
                window.document.body.style.position = '';
                window.document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
            }
        }
    }, [isNavMenuOpen]);
    return (React.createElement(MobileNavigationContainer, null,
        React.createElement(Header, null,
            React.createElement(ImageLink, { media: siteLogo, linkField: { value: { href: '/' } }, type: IMAGE_TYPE.ICON, desktopHeight: NAV_LOGO.HEIGHT_MOBILE, maxWidth: NAV_LOGO.WIDTH }),
            React.createElement(FlexContainer, null,
                React.createElement(LanguageToggle, { currentLanguage: currentLanguage, languages: languageToggleOptions }),
                React.createElement(NavMenuButton, { isMenuOpen: isNavMenuOpen, setOpen: setNavMenuToOpen }))),
        navigationItems && (React.createElement(DropdownPanel, { shouldDisplayDropdown: isNavMenuOpen, dropdownOffset: navigationHeight },
            React.createElement(VerticalNavigation, { navigationItems: navigationItems, siteOwner: siteOwner, setChildMenuData: setChildMenuData, setChildMenuLabel: setChildMenuLabel, setChildMenuToOpen: () => setChildMenuToOpen(!shouldChildMenuOpen), currentSite: currentSite, currentLanguage: currentLanguage, allowContentToBeTabable: isNavMenuOpen, onClose: () => setNavMenuToOpen(false) }))),
        shouldChildMenuOpen && (React.createElement(SlidePanel, { childMenuLabel: childMenuLabel, navigationItems: childMenuData, siteOwner: siteOwner, clearChildMenuData: clearChildMenuData, currentSite: derivedSiteName, currentLanguage: currentLanguage, allowContentToBeTabable: shouldChildMenuOpen }))));
};
export { MobileNavigation };
